import { Formation } from "../types"

export const posfor4es: Formation = {
  id: "posfor4es",
  name: "4",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 3.154482514485094,
          y: 4.468732590031595
        },
        {
          x: 7.467727624672146,
          y: 6.3975153732755565
        },
        {
          x: 10.692263166821844,
          y: 3.483582582097754
        },
        {
          x: 7.13992579379247,
          y: 2.5568076695450177
        },
        {
          x: 12.67749275016101,
          y: 1.7813704660431602
        },
        {
          x: 1.36168700734347,
          y: 1.5758176596218825
        }
      ],
      opponents: [
        {
          x: 5.466248543031754,
          y: 4.5044630773036145
        },
        {
          x: 8.41759156440179,
          y: 3.382850382632822
        },
        {
          x: 10.882409445558682,
          y: 1.92971841864546
        },
        {
          x: 9.513935285087413,
          y: 4.517402056439946
        },
        {
          x: 4.1731703563403055,
          y: 2.6631620491419783
        }
      ],
      ball: {
        x: 12.443031939981658,
        y: 2.7240232880112663
      },
      goalkeepers: [
        {
          x: 7.079437073556041,
          y: 1.087305340145936
        }
      ]
    }
  ]
}
